require('ta-semantic-ui/semantic/dist/components/icon.css');
require('ta-semantic-ui/semantic/dist/components/button.css');
require('ta-semantic-ui/semantic/dist/components/dimmer.css');
require('./section3.styl');

import React from 'react';

import Lightbox from 'react-image-lightbox';

import Image3 from './imgs/3.jpg';

class Section3 extends React.Component {

    constructor(props) {
        super(props);

        this.state=({
          isOpen: false
        })

    }

    render() {

        return (

            <div className='section three wrapper'>

                <div className={`ui  dimmable ${this.props.readerMadeHisChoice ? '' : 'dimmed'} segment padded`}>
                    <div className='ui inverted simple dimmer'></div>
                        {/*<h3>Das ist schon die dritte Sektion</h3>*/}
                            <p className='section-text'>
                              Seit er 14 war, begleitet Oliver seine Krankheit. Ein typisches Symptom der Narkolepsie sind sogenannte <a href='https://de.wikipedia.org/wiki/Kataplexie' target='_blank'>Kataplexien</a>, Lähmungserscheinungen. Sie treten beispielsweise beim Jassen auf, wenn Oliver ein gutes Blatt hat. Denn: «Emotionen lösen Anfälle aus.» Oliver versuchte, sich mit der Narkolepsie zu arrangieren: <strong>Medikamente, Yoga, Meditation, Schlafpausen.</strong> Das hat alles lange funktioniert. Im Gymnasium wurde ihm extra ein Notfallbett im Putzraum zur Verfügung gestellt. Während des Studiums schlief er jeweils im Kopierraum. Und weil die Arbeit als Angestellter für den Narkoleptiker schwierig war, machte er sich im Jahr 2000 selbstständig.                            </p>

                  { this.state.isOpen &&
                  <Lightbox
                    mainSrc={Image3}
                    imageCaption='Kosten viel Geld: Die Narkolepsie zwingt Oliver dazu, täglich Medikamente zu schlucken.'
                    onCloseRequest={() => this.setState({isOpen: false})}
                  />
                  }


                  <div className='section text image wrapper'>

                    <img
                      src={Image3} width='100%'
                      onClick={() => this.setState({ isOpen: true })}
                    />

                    <p className='bild legend'>Kosten viel Geld: Die Narkolepsie zwingt Oliver dazu, täglich Medikamente zu schlucken.</p>
                  </div>

                  <p className='section-text'>
                    Der 45-Jährige kramt aus einer durchsichtigen Plastikkiste Flyer, Plakate, Flugblätter und Zeitungen von Zürcher Kulturinstitutionen  hervor. Er atmet schnell, präsentiert sichtlich stolz seine Werke von früher: «Man kann die Plakate direkt nebeneinander aufhängen. Sehen Sie, die Muster gehen fliessend ineinander über.» Drei Jahre hat er Grafik und Design studiert, 1995 abgeschlossen. 14 Jahre lang hat er als Selbstständiger von zu Hause aus einen Umsatz von 50'000 bis 60'000 Franken erwirtschaftet. Seine damalige Partnerin, die Mutter des gemeinsamen Sohnes, arbeitete als Lehrerin und verdiente rund 6000 Franken im Monat. <strong>«Ich war nie reich, aber es hat gereicht.»</strong>
                            </p>

                  <p className='section-text'>
                    Wenn er heute Bekannten sage, er habe kein Geld, könnten zahlreiche das nicht einordnen, sagt Oliver. Für viele Zürcher sei man schon arm, wenn man sich nicht das neuste iPhone leisten kann. Sie können es sich nicht vorstellen, wie es ist, im <a href='http://www.caritas-zuerich.ch/caritaszh/hilfe-finden/guenstiger-leben/guenstige-lebensmittel-im-caritas-markt' target='_blank'>Caritas-Markt</a> einkaufen zu gehen, sich darüber Gedanken machen zu müssen, welches Brot man kauft, um einige Rappen zu sparen. Sie kennen den Preis nicht einmal. «Ich wusste genau, welches Brot 2,80 Franken und welches 3,40 Franken kostet.»
                  </p>

                </div>

            </div>
        );
    }
}

Section3.defaultProps = {};

Section3.propTypes = {
    readerIsCityCitizen: React.PropTypes.bool,
    readerMadeHisChoice: React.PropTypes.bool
};

export default Section3;



// WEBPACK FOOTER //
// ./src/components/section3/Section3.js